var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("PortfolioNavigation", {
        attrs: { workspaceId: _vm.workspaceId, projectId: _vm.tchProjectId },
      }),
      _vm._v(" "),
      _vm.rm
        ? _c(
            "div",
            {
              staticClass: "container-fluid",
              staticStyle: { "margin-top": "80px", "padding-top": "20px" },
            },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-lg-6" }, [
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(
                      _vm._s(_vm.rm.PortfolioName) +
                        " / " +
                        _vm._s(_vm.rm.ScenarioName)
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "h1",
                    {
                      staticStyle: {
                        "font-size": "2em",
                        "font-weight": "300",
                        color: "#33475b",
                        margin: "0",
                      },
                    },
                    [_vm._v("Plan: Review")]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-lg-6 d-flex flex-column justify-content-end",
                  },
                  [
                    _c("PortfolioScenarioNavigation", {
                      attrs: {
                        portfolioId: _vm.rm.PortfolioId,
                        corporateScenarioUrl: _vm.rm.CorporateScenarioUrl,
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("hr", {
                staticStyle: { "border-color": "#bbb", margin: "20px 0 60px" },
              }),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "toolbar" }, [
                _c("div"),
                _vm._v(" "),
                _c("div", [
                  _c("div", { staticClass: "btn-group mr-2" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-secondary",
                        attrs: { type: "button" },
                        on: { click: _vm.handleShowGridColumnsEditor },
                      },
                      [
                        _vm._v(
                          "\n                        Edit columns\n                    "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-secondary",
                        attrs: {
                          type: "button",
                          title: "Save current grid layout and filters",
                        },
                        on: { click: _vm.handleSaveReviewGridCommand },
                      },
                      [
                        _vm._v(
                          "\n                        Save view\n                    "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "btn-group" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-outline-secondary dropdown-toggle",
                        attrs: { type: "button", "data-toggle": "dropdown" },
                      },
                      [
                        _vm._v(
                          "\n                        Actions\n                    "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "dropdown-menu dropdown-menu-right" },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "dropdown-item",
                            on: { click: _vm.handleExportGrid },
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-download fa-sm mr-1",
                            }),
                            _vm._v(
                              " Download to spreadsheet\n                        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "dropdown-item",
                            on: { click: _vm.handleClearGridFilters },
                          },
                          [
                            _vm._v(
                              "\n                            Clear Filters\n                        "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("ProjectsGrid", { attrs: { viewModel: _vm.grid } }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      { staticClass: "alert alert-warning", attrs: { role: "alert" } },
      [
        _c("p", { staticClass: "mb-0" }, [
          _vm._v(
            "\n                Please note that project-level data in this report is based on the start date in\n                "
          ),
          _c("strong", [_vm._v("Kanban")]),
          _vm._v(" & "),
          _c("strong", [_vm._v("Active Business Case")]),
          _vm._v(".\n            "),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }